import { makeAutoObservable } from 'mobx';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import { ScanIqCustomer } from '../../scan-iq-customer-management/interfaces/ScanIqCustomer';
import { challengeSignUpService } from '../services/challengeSignUpService';
import { ChallengeSignUpEntityData } from '../interfaces/ChallengeSignUpEntityData';
import { ChallengePaymentInfo } from '../../payment/interfaces/challengePaymentInfo';
import {
  challengePaymentService,
  CurrentSubscriptionInfo,
  PromoCodeInfo,
} from '../../payment';
import { CHALLENGE_CUSTOMER_TYPE } from '../constants/challengeCustomerType';

class ChallengeSignUpStore {
  challengeId: number | null = null;
  participantId: number | null = null;
  customer: ScanIqCustomer | null = null;
  entityData: ChallengeSignUpEntityData | null = null;
  challengePaymentInfo: ChallengePaymentInfo | null = null;
  appliedPromoCode: PromoCodeInfo | null = null;
  nutritionSubscriptionInfo: CurrentSubscriptionInfo | null = null;

  get isLifeBaseWithoutActiveSubscription(): boolean {
    return (
      this.challengePaymentInfo?.challengeCustomerType ===
        CHALLENGE_CUSTOMER_TYPE.LIFE_BASE_USERS &&
      !this.nutritionSubscriptionInfo?.subscription
    );
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.customer = null;
    this.challengeId = null;
    this.participantId = null;
    this.entityData = null;
    this.challengePaymentInfo = null;
    this.appliedPromoCode = null;
    this.nutritionSubscriptionInfo = null;
  }

  setCustomer(customer: ScanIqCustomer) {
    this.customer = customer;
  }

  setChallengeId(challengeId: number) {
    this.challengeId = challengeId;
  }

  setParticipantId(participantId: number) {
    this.participantId = participantId;
  }

  setEntityData(entityData: ChallengeSignUpEntityData) {
    this.entityData = entityData;
  }

  setChallengePaymentInfo(challengePaymentInfo: ChallengePaymentInfo) {
    this.challengePaymentInfo = challengePaymentInfo;
  }

  setAppliedPromoCode(appliedPromoCode: PromoCodeInfo) {
    this.appliedPromoCode = appliedPromoCode;
  }

  async getEntityData(challengeId: number) {
    const entityData =
      await challengeSignUpService.getChallengeSignUpEntityData(challengeId);
    this.setEntityData(entityData);
  }

  private async getNutritionSubscriptionInfo() {
    if (!this.participantId) {
      return;
    }

    const info = await challengePaymentService.getNutritionSubscriptionInfo(
      this.participantId,
    );
    this.nutritionSubscriptionInfo = info;
  }

  async getChallengePaymentInfo() {
    if (!this.participantId) {
      throw new Error('Participant ID is not defined');
    }

    const challengePaymentInfo = await challengePaymentService.getChallengePaymentInfo(
      this.participantId,
    );
    this.setChallengePaymentInfo(challengePaymentInfo.challengeSetup);

    if (challengePaymentInfo.promocode) {
      this.setAppliedPromoCode(challengePaymentInfo.promocode);
    }

    if (
      challengePaymentInfo.challengeSetup.challengeCustomerType ===
      CHALLENGE_CUSTOMER_TYPE.LIFE_BASE_USERS
    ) {
      await this.getNutritionSubscriptionInfo();
    }
  }
}

const challengeSignUpStore = new ChallengeSignUpStore();
resetAllStore.addResetMethod(challengeSignUpStore.setDefaultValues);

export { challengeSignUpStore, ChallengeSignUpStore };
